<template>
    <router-link
        v-if="item.visible"
        class="navbar-item"
        exact-path
        active-class="is-active"
        :to="{ name: item.name }"
    >
        {{ item.label }}
    </router-link>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => {},
        },
    },
};
</script>
